<script setup lang="ts">
const { t, locale } = useI18n()
const crumbs = usePageMeta('privacy')
</script>

<template>
  <div>
    <PageHeader
      :title="t('privacy.title')"
      :crumbs="crumbs"
    />
    <div class="container-site section pt-6">
      <div class="prose-dg">
        <PrivacyDe v-if="locale === 'de'" />
        <PrivacyEn v-else />
      </div>
    </div>
  </div>
</template>
